import * as style from './style.module.css';

const Loader = ({ className = '' }) => {
    return <div className={`${style.loader} ${className}`}>
        <div />
        <div />
        <div />
        <div />
    </div>
};

export default Loader;